if (!customElements.get('sande-feature-explorer')) {
  customElements.define('sande-feature-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-feature-button]')];
      this.panels = [...this.querySelectorAll('[data-feature-panel]')];
      this.track = this.querySelector('.sande-story__images');
      this.progress = this.querySelector('.sande-story__progress span');
      if (!this.panels.length) return;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.setAttribute('data-enhanced', '');
      this.show(this.panels[0].dataset.featurePanel);
      this.mobile.addEventListener('change', () => this.show(this.activeId, true), options);
      this.buttons.forEach(button => button.addEventListener('click', () => this.show(button.dataset.featureButton, true), options));
      this.track.addEventListener('scroll', () => {
        if (!this.mobile.matches) return;
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const left = this.track.getBoundingClientRect().left + parseFloat(getComputedStyle(this.track).paddingLeft);
          const closest = this.panels.reduce((a, b) => Math.abs(a.getBoundingClientRect().left - left) < Math.abs(b.getBoundingClientRect().left - left) ? a : b);
          if (closest.dataset.featurePanel !== this.activeId) this.show(closest.dataset.featurePanel);
        });
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = this.panels.findIndex(panel => panel.dataset.featurePanel === this.activeId);
        const next = Math.max(0, Math.min(this.panels.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        this.show(this.panels[next].dataset.featurePanel, true);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const target = event.target.closest('[data-feature-button], [data-feature-panel]');
        if (target && this.contains(target)) this.show(target.dataset.featureButton || target.dataset.featurePanel, true);
      }, options);
    }
    show(id, scroll = false) {
      this.activeId = id;
      const index = this.panels.findIndex(panel => panel.dataset.featurePanel === id);
      this.progress.style.width = `${100 / this.panels.length}%`;
      this.progress.style.transform = `translateX(${index * 100}%)`;
      this.progress.parentElement.hidden = this.panels.length < 2;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.featureButton === id)));
      this.panels.forEach(panel => {
        const active = panel.dataset.featurePanel === id;
        panel.hidden = !this.mobile.matches && !active;
        panel.querySelectorAll('video').forEach(video => {
          video.muted = true;
          video.autoplay = active;
          if (!active) video.pause();
          else video.play()?.catch(() => {});
        });
        if (active && scroll && this.mobile.matches) this.track.scrollTo({ left: this.track.scrollLeft + panel.getBoundingClientRect().left - this.track.getBoundingClientRect().left - parseFloat(getComputedStyle(this.track).paddingLeft), behavior: 'instant' });
      });
      this.track.tabIndex = this.mobile.matches ? 0 : -1;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.scrollFrame);
      this.querySelectorAll('video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
  });
}
